export default "__VITE_ASSET__Diz35O9K__"